export default class ibanValidator {
    constructor() {
    }

    validate(value) {
        value = value.toUpperCase();
        const country = value.slice(0, 2);

        switch (country) {
            case 'AD':
                return !!(value.match(/^AD[0-9]{22}$/));

            case 'AE':
                return !!(value.match(/^AE[0-9]{21}$/));

            case 'AL':
                return !!(value.match(/^AL[0-9]{26}$/));

            case 'AT':
                return !!(value.match(/^AT[0-9]{20}$/));

            case 'AZ':
                return !!(value.match(/^AZ[0-9]{2}[A-Z]{4}[0-9]{20}$/));

            case 'BA':
                return !!(value.match(/^BA[0-9]{18}$/));

            case 'BE':
                return !!(value.match(/^BE[0-9]{14}$/));

            case 'BG':
                return !!(value.match(/^BG[0-9]{2}[A-Z]{4}[0-9]{14}$/));

            case 'BH':
                return !!(value.match(/^BH[0-9]{2}[A-Z]{4}[0-9]{14}$/));

            case 'BR':
                return !!(value.match(/^BR[0-9]{25}[A-Z][0-9]$/));

            case 'CR':
                return !!(value.match(/^CR[0-9]{19}$/));

            case 'CH':
                return !!(value.match(/^CH[0-9]{19}$/));

            case 'CY':
                return !!(value.match(/^CY[0-9]{26}$/));

            case 'CZ':
                return !!(value.match(/^CZ[0-9]{22}$/));

            case 'DE':
                return !!(value.match(/^DE[0-9]{20}$/));

            case 'DK':
                return !!(value.match(/^DK[0-9]{16}$/));

            case 'DO':
                return !!(value.match(/^DO[0-9]{2}[A-Z]{2}[0-9]{20}$/));

            case 'EE':
                return !!(value.match(/^EE[0-9]{18}$/));

            case 'ES':
                return !!(value.match(/^ES[0-9]{22}$/));

            case 'FI':
                return !!(value.match(/^FI[0-9]{16}$/));

            case 'FO':
                return !!(value.match(/^FO[0-9]{16}$/));

            case 'FR':
                return !!(value.match(/^FR[0-9]{19}[A-Z][0-9]{5}$/));

            case 'GB':
                return !!(value.match(/^GB[0-9]{2}[A-Z]{4}[0-9]{14}$/));

            case 'GE':
                return !!(value.match(/^GE[0-9]{2}[A-Z]{2}[0-9]{16}$/));

            case 'GI':
                return !!(value.match(/^GI[0-9]{2}[A-Z]{4}[0-9]{15}$/));

            case 'GL':
                return !!(value.match(/^GL[0-9]{16}$/));

            case 'GR':
                return !!(value.match(/^GR[0-9]{25}$/));

            case 'GT':
                return !!(value.match(/^GT[0-9]{2}[A-Z]{4}[0-9]{20}$/));

            case 'HR':
                return !!(value.match(/^HR[0-9]{19}$/));

            case 'HU':
                return !!(value.match(/^HU[0-9]{26}$/));

            case 'IE':
                return !!(value.match(/^IE[0-9]{2}[A-Z]{4}[0-9]{14}$/));

            case 'IL':
                return !!(value.match(/^IL[0-9]{21}$/));

            case 'IS':
                return !!(value.match(/^IS[0-9]{24}$/));

            case 'IT':
                return !!(value.match(/^IT[0-9]{2}[A-Z][0-9]{22}$/));

            case 'KW':
                return !!(value.match(/^KW[0-9]{2}[A-Z]{4}[0-9]{22}$/));

            case 'KZ':
                return !!(value.match(/^KZ[0-9]{5}[A-Z]{3}[0-9]{10}$/));

            case 'LB':
                return !!(value.match(/^LB[0-9]{26}$/));

            case 'LI':
                return !!(value.match(/^LI[0-9]{17}[A-Z]{2}$/));

            case 'LT':
                return !!(value.match(/^LT[0-9]{18}$/));

            case 'LU':
                return !!(value.match(/^LU[0-9]{18}$/));

            case 'LV':
                return !!(value.match(/^LV[0-9]{2}[A-Z]{4}[0-9]{13}$/));

            case 'MC':
                return !!(value.match(/^MC[0-9]{22}[A-Z][0-9]{2}$/));

            case 'MD':
                return !!(value.match(/^MD[0-9]{2}[A-Z]{2}[0-9]{18}$/));

            case 'ME':
                return !!(value.match(/^ME[0-9]{20}$/));

            case 'MK':
                return !!(value.match(/^MK[0-9]{17}$/));

            case 'MR':
                return !!(value.match(/^MR[0-9]{25}$/));

            case 'MT':
                return !!(value.match(/^MT[0-9]{2}[A-Z]{4}[0-9]{12}[A-Z]{7}[0-9]{3}[A-Z]$/));

            case 'MU':
                return !!(value.match(/^MU[0-9]{2}[A-Z]{4}[0-9]{19}[A-Z]{3}$/));

            case 'NL':
                return !!(value.match(/^NL[0-9]{2}[A-Z]{4}[0-9]{10}$/));

            case 'NO':
                return !!(value.match(/^NO[0-9]{13}$/));

            case 'PK':
                return !!(value.match(/^PK[0-9]{2}[A-Z]{4}[0-9]{16}$/));

            case 'PL':
                return !!(value.match(/^PL[0-9]{26}$/));

            case 'PS':
                return !!(value.match(/^PS[0-9]{2}[A-Z]{4}[0-9]{21}$/));

            case 'PT':
                return !!(value.match(/^PT[0-9]{23}$/));

            case 'RO':
                return !!(value.match(/^RO[0-9]{2}[A-Z]{4}[0-9]B[0-9]{14}$/));

            case 'RS':
                return !!(value.match(/^RS[0-9]{20}$/));

            case 'SA':
                return !!(value.match(/^SA[0-9]{22}$/));

            case 'SE':
                return !!(value.match(/^SE[0-9]{22}$/));

            case 'SI':
                return !!(value.match(/^SI[0-9]{17}$/));

            case 'SK':
                return !!(value.match(/^SK[0-9]{22}$/));

            case 'SM':
                return !!(value.match(/^SM[0-9]{2}[A-Z][0-9]{22}$/));

            case 'TN':
                return !!(value.match(/^TN[0-9]{22}$/));

            case 'TR':
                return !!(value.match(/^TR[0-9]{24}$/));

            case 'VG':
                return !!(value.match(/^VG[0-9]{2}[A-Z]{4}[0-9]{16}$/));
        }

        return false;
    }
}
